import { BaseSearchResults } from './BaseSearchResults';

export { type BaseSearchResultsProps } from './BaseSearchResults';
export default BaseSearchResults;
